import axios from "./axios";
import AppConfig from "../../config";

export default class loginService {
  changeLangauge = async (body,Lang) => {
    const url = `${AppConfig.BASE_URL}:${AppConfig.RESOURCE_MANAGER_PORT}/language/company`;
    //console.log("getCustomerProfile url", url);
    const config = {
      method: "post",
      url: url,
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer",
        lang: Lang,
      },
    };
    const results = await axios.post(url,body, config);
    const response = await results;
    //console.log("getCustomerProfile response: ", JSON.stringify(response));
    return response;
  };
}

export { loginService }